type Param = string | undefined | false | null;
type ParamArray = Param[]

/**
 * Joins class value params into a single className
 * @param classValues 
 * @returns A 'class' value for the html element
 */
export const cn = (...classValues: ParamArray) => {
    let s = '';
    for(const cv of classValues) {
        if (cv) s = `${s} ${cv}`;
    }
    return s;
} 